The salary or compensation for a position to be previewed prior to posting.
